<template>
  <div class="notFound container">
    <b-card-header>
      <b-card-title>{{ $t('errors.status.notFound') }}</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-link :to="{ name: 'reporters' }">{{
        $t('globals.buttons.back')
      }}</b-link></b-card-body
    >
  </div>
</template>

<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'NotFound',
  extends: LocalizableComponent,
  data() {
    return {}
  }
}
</script>

<style scoped>
.notFound {
  height: 100vh;
  background: rgba(1, 1, 1, 0);
}
</style>
